import { LocationDto } from '@fleet-beat/core';

export interface AddressDto extends LocationDto {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  stateAbbr?: string;
  postal?: string;
  country?: string;
  countryAbbr?: string;
  placeId?: string;
  lat?: string;
  lon?: string;
  url?: string;
}

export interface PlaceByCoordinatesDto extends AddressDto {
  featureId: number;
  featureName: string;
  featureClass: string;
  stateName: string;
  stateNumeric: string;
  countyName: string;
  countyNumeric: string;
  mapName: string;
  distance: number;
  distanceMil: number;
  stateAbbr: string;
  direction: string;
  address: string;
}
